module.exports = __webpack_public_path__ + "img/icon-line.ac222f80.svg";